import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  loadingPage: false,
  savingForm: false,

  lang: process.env.VUE_APP_DEFAULT_LANGUAGE,

  device: 'default',

  cmsLoading: false,
  cmsError: false,
  cms: {},
  cmsId: null,

  homepageBlocksLoading: false,
  homepageBlocksError: false,
  homepageBlocks: [
    {
      title: null,
      type: null,
      endpoint: '',
      see_more: '',
      slug: null,
      items: []
    },
    {
      title: null,
      type: null,
      endpoint: '',
      see_more: '',
      slug: null,
      items: []
    }
  ],

  toggleFeatures: {},
  period: [],
  periodLoading: false,
  periodError: false,

  pageToolbar: false,
  pageToolbarTitle: null,
  pageToolbarSubtitle: null,
  pageToolbarDropdown: false,
  pageToolbarSelect: false,
  pageToolbarDropdownList: null,
  pageToolbarDropdownSelectedItem: null,
  pageToolbarButton: false,
  pageToolbarButtonLabel: null,
  pageToolbarInfoIcon: false,
  pageToolbarNotificationIcon: false,
  pageNavigationDrawer: false,
  pageBottomNavigation: false,
  pageMobileLayoutType: null,
  pageMobileSelectedMenu: null,
  pageDesktopLayoutType: null,
  pageDesktopSelectedMenu: null,
  pageDialog: null,
  prevPeriod: null,
  hidePayment: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
